module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//pet-default.png?v=c3c0106d";